var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21C6.07626 18.3768 8.89513 16.7647 12 16.7647C15.1049 16.7647 17.9237 18.3768 20 21M16.8 7.76471C16.8 10.3962 14.651 12.5294 12 12.5294C9.34903 12.5294 7.2 10.3962 7.2 7.76471C7.2 5.13323 9.34903 3 12 3C14.651 3 16.8 5.13323 16.8 7.76471Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser03);
export default __webpack_public_path__ + "static/media/user-03.9ba0da6e7a468a5b087b7cd44352368c.svg";
export { ForwardRef as ReactComponent };